import { createSlice } from '@reduxjs/toolkit';
import { objectFitValues } from '../../utils/constants';



export const playerSettings = createSlice({
    name: 'playerSettings',
    initialState: {
        objectFit: "contain",
    },
    reducers: {
        changeObjctFit: (state) => {
            const nextIndex = objectFitValues.indexOf(state.objectFit) + 1
            const fixedIndex = nextIndex >= objectFitValues.length ? 0 : nextIndex
            state.objectFit = objectFitValues[fixedIndex];
        },
        setObjctFit: (state, {payload}) => {
            state.objectFit = payload;
        },
    },
});


export default playerSettings;
